/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Orderaddinfo_Name2Inputs */

const en_resources_orderaddinfo_name2 = /** @type {(inputs: Resources_Orderaddinfo_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Additional Info`)
};

const fr_resources_orderaddinfo_name2 = /** @type {(inputs: Resources_Orderaddinfo_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infos complémentaires`)
};

const es_resources_orderaddinfo_name2 = /** @type {(inputs: Resources_Orderaddinfo_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información adicional`)
};

const de_resources_orderaddinfo_name2 = /** @type {(inputs: Resources_Orderaddinfo_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusatzinformationen`)
};

const nl_resources_orderaddinfo_name2 = /** @type {(inputs: Resources_Orderaddinfo_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanvullende informatie`)
};

/**
* | output |
* | --- |
* | "Additional Info" |
*
* @param {Resources_Orderaddinfo_Name2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_orderaddinfo_name2 = /** @type {((inputs?: Resources_Orderaddinfo_Name2Inputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Orderaddinfo_Name2Inputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_orderaddinfo_name2(inputs)
	if (locale === "fr") return fr_resources_orderaddinfo_name2(inputs)
	if (locale === "es") return es_resources_orderaddinfo_name2(inputs)
	if (locale === "de") return de_resources_orderaddinfo_name2(inputs)
	return nl_resources_orderaddinfo_name2(inputs)
});
export { resources_orderaddinfo_name2 as "resources.orderAddInfo.name" }